/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AmoxcalliCreateGroupDto } from '../../models/amoxcalli-create-group-dto';
import { AmoxcalliGroupDtoApiResponse } from '../../models/amoxcalli-group-dto-api-response';

export interface ApiGroupsPost$Json$Params {
      body?: AmoxcalliCreateGroupDto
}

export function apiGroupsPost$Json(http: HttpClient, rootUrl: string, params?: ApiGroupsPost$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<AmoxcalliGroupDtoApiResponse>> {
  const rb = new RequestBuilder(rootUrl, apiGroupsPost$Json.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AmoxcalliGroupDtoApiResponse>;
    })
  );
}

apiGroupsPost$Json.PATH = '/api/groups';
